import { getIncludeAnalogs } from '../selectors';
import { dataFrom } from './_hoc';
import { RText } from './elements';
import {
    React,
    TouchableOpacity,
    View
} from './react';
import { yesNo as style } from './style';

function applyActiveStyle(isActive, styl) {
    return isActive ? styl : {};
}

export const YesNo = dataFrom(getIncludeAnalogs, ({
    data,
    onChange,
}) => (
    <View style={style.btnsWrapper}>
        <TouchableOpacity
            onPress={() => onChange(true)}
            style={[ style.button,
                style.buttonLt,
                applyActiveStyle(data, style.buttonActive) ]}
        >
            <RText
                style={[ style.buttonTxt,
                    applyActiveStyle(data, style.buttonActiveTxt) ]}
                id="buttons.yes"
            />
        </TouchableOpacity>
        <TouchableOpacity
            onPress={() => onChange(false)}
            style={[ style.button,
                style.buttonRt,
                applyActiveStyle(!data, style.buttonActive) ]}
        >
            <RText
                style={[ style.buttonTxt,
                    applyActiveStyle(!data, style.buttonActiveTxt) ]}
                id="buttons.no"
            />
        </TouchableOpacity>
    </View>
));
